import Link from 'next/link';
import * as React from 'react';

interface IRedirectionCardProps {
  children: React.ReactNode;
  url?: string;
  attributeTitle?: string;
  variant?: 'primary' | 'clear';
  withTitleOnly?: boolean;
  onClick?: () => any;
  isTargetBlank?: boolean;
  UNSAFE_className?: string;
}

const RedirectionCard: React.FC<IRedirectionCardProps> = ({
  children,
  url,
  attributeTitle,
  variant = 'primary',
  withTitleOnly = false,
  onClick,
  isTargetBlank = false,
  UNSAFE_className,
}) => {
  const className = `${UNSAFE_className} tw-group tw-grid tw-w-full tw-max-w-[600px] tw-items-center tw-justify-between
  tw-rounded-lg tw-border tw-border-solid ${
    variant === 'primary' ? 'tw-border-yellow-600' : 'tw-border-black-150'
  }
  tw-px-3 tw-py-4 
  ${
    withTitleOnly
      ? 'tw-grid-template-[title_button]'
      : 'tw-grid-template-[title_button|subtitle_button]'
  }
  hover:tw-cursor-pointer`;

  if (url) {
    return (
      <Link
        href={url}
        title={attributeTitle || ''}
        className={`${className}`}
        target={isTargetBlank ? '_blank' : '_self'}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      type="button"
      title={attributeTitle || ''}
      onClick={onClick}
      className={`tw-lf-button-clear ${className}`}
    >
      {children}
    </button>
  );
};

export default RedirectionCard;
